<template>
  <h1>Answered Leads</h1>
</template>
<script>
export default {
  name: "AnsweredLeads",
};
</script>
